module.exports = __webpack_public_path__ + "static/media/linkedin.ed2b8f8f.svg";